// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { useNetworkStatus } from '../hooks/useNetworkStatus';

/**
 * Shows a subtle banner when the app is offline.
 * Positioned at the top of the content area, below the header.
 * Auto-hides when connectivity is restored.
 */
export default function OfflineBanner() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      data-testid="offline-banner"
      role="status"
      aria-live="polite"
      className="mx-4 mt-2 mb-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-800"
    >
      You&apos;re offline &mdash; showing cached data
    </div>
  );
}
